/**
 * Haitian Creole for content/tutorials.ts, keyed by the English tutorial `id`.
 *
 * The ENGLISH file remains the structural source of truth — ids, order, step count and the
 * `minutes` estimate all come from it. This file supplies strings only, so a tutorial cannot exist
 * in one language and not the other, and the two cannot drift into different orders.
 *
 * Written in the official 1979 IPN orthography (see content/ui.ts for the rules that apply).
 */

export type TutorialStrings = {
  title: string;
  intro: string;
  prerequisites: string[];
  steps: { name: string; text: string }[];
  note?: string;
};

export const TUTORIALS_HT: Record<string, TutorialStrings> = {
  "create-your-twoke-account": {
    title: "Kreye kont twoke w",
    intro:
      "Enskri ak yon adrès imèl epi yon modpas, epi aksepte de konsantman twoke mande anvan okenn fonksyon trading debloke.",
    prerequisites: ["Yon adrès imèl ou ka resevwa mesaj sou li."],
    steps: [
      {
        name: "Louvri paj enskripsyon an",
        text: "Ale sou paj akèy twoke a epi chwazi Kòmanse, oswa ale dirèk sou /signup. Deklarasyon risk trading lan parèt anvan tout bagay — li li. Li di klè ke trading futures ak leverage ka fè w pèdi yon pati oswa tout kripto ou, ke copy trading se pa konsèy finansye, epi ke abònman pa ranbousab.",
      },
      {
        name: "Aksepte deklarasyon risk la",
        text: "Lè ou dakò, sistèm nan anrejistre deklarasyon an sou kont ou ak nimewo vèsyon li. Si tèks deklarasyon an chanje pita, y ap mande w aksepte nouvo vèsyon an anvan ou ka konekte yon kle oswa abòne ankò. Se sèvè a ki fè kontwòl sa a, se pa paj la sèlman, donk ou pa ka sote l lè ou pase dirèk sou API a.",
      },
      {
        name: "Antre imèl ou epi chwazi yon modpas",
        text: "Modpas dwe gen omwen 12 karaktè. Pou sekirite w, yon sesyon dire inèdtan apre ou konekte. Koche kaz sonje mwen an pou sesyon an rete si ou fèmen epi relouvri navigatè a nan inèdtan sa a, oswa kite l vid pou sesyon an fini lè ou fèmen navigatè a. Si ou pito pa itilize modpas lè w ap konekte, ou ka mande yon kòd 6 chif pa imèl nenpòt kilè sou paj koneksyon an.",
      },
      {
        name: "Aksepte Kondisyon Sèvis yo",
        text: "Kondisyon yo pote règ pa gen ranbousman an, donk sistèm nan anrejistre akseptasyon an ak yon nimewo vèsyon sou kont ou, epi li obligatwa anvan ou ka abòne ak yon mèt oswa konekte yon kle echanj. Y ap redemande w si vèsyon Kondisyon yo chanje.",
      },
    ],
    note: "Kreye yon kont pa koute anyen epi li pa konekte ak okenn echanj. Anyen pa ka fè trading toutotan ou pa konekte yon kle echanj epi achte yon abònman, nan lòd sa a.",
  },

  "connect-your-exchange-api-key": {
    title: "Konekte kle API Bybit, Binance oswa MEXC ou",
    intro:
      "Kreye yon kle API ki sèvi sèlman pou trading sou echanj ou epi konekte l ak twoke, konsa trade yon mèt ka plase sou pwòp kont ou. Fè sa anvan ou abòne — yo achte yon abònman pou yon kont echanj presi.",
    prerequisites: [
      "Yon kont twoke kote ou deja aksepte deklarasyon risk la ak Kondisyon yo.",
      "Yon kont Bybit, Binance oswa MEXC. Sou Bybit oswa Binance, yon kont demo oswa testnet ase pou kòmanse; MEXC pa gen demo.",
      "Aksè ak adrès imèl kont twoke w, pou kòd verifikasyon an.",
    ],
    steps: [
      {
        name: "Kreye yon kle API sou echanj ou",
        text: "Sou Bybit, louvri API Management epi kreye yon kle ak pèmisyon Contract trading ak lekti. Sou Binance, louvri API Management epi aktive Reading ak Futures. Sou toude, kite pèmisyon retrè a FÈMEN — twoke pa janm bezwen l, epi yon kle ki pa ka fè retrè pa ka deplase kripto ou menm si li ta fwite. Kopye kle a ak sekrè a; sekrè a parèt yon sèl fwa.",
      },
      {
        name: "Chwazi demo oswa kont reyèl",
        text: "Deside si kle sa a ap pwente sou anviwònman demo oswa testnet echanj lan, oswa sou kont reyèl. Demo se chwa pa defo epi se konsa nou rekòmande w kòmanse — yon moun sou demo resevwa menm trade yo, menm kalkil gwosè a ak menm jesyon stop-loss la ak yon moun sou kont reyèl, men ak balans demo. Kreye kle a nan anviwònman ki koresponn nan: yon kle demo pa ka otantifye sou anviwònman reyèl la.",
      },
      {
        name: "Mande kòd verifikasyon w",
        text: "Nan tablo twoke a, louvri seksyon Kont yo epi kòmanse konekte yon kont. Mande yon kòd verifikasyon, y ap voye l ba ou pa imèl, 6 chif. Li ekspire apre 5 minit, li mache yon sèl fwa, epi yo estoke l sèlman anba fòm hash. Konekte yon kle mande kòd sa a menm si ou deja konekte — modpas ou se sa ou konnen, kòd sa a se sa ou genyen.",
      },
      {
        name: "Antre kle a, sekrè a ak yon etikèt",
        text: "Kole kle API a ak sekrè a, chwazi echanj lan, konfime paramèt demo oswa reyèl la, epi bay kont lan yon etikèt ou ka rekonèt pita — etikèt la se konsa w ap fè diferans ant kont ou yo nan tablo a. Yo chifre sekrè a ak AES-256-GCM menm moman li rive epi yo pa janm estoke ni anrejistre l anba fòm lizib.",
      },
      {
        name: "Verifye kont lan parèt",
        text: "Kont lan parèt kounye a nan tablo w ak yon kle API tronke. L ap di tou ke li pa gen abònman epi li p ap kopye anyen. Sa nòmal epi se konsa li dwe ye: yon kle ki konekte san abònman se yon kle inaktif — sistèm ki distribiye trade yo chwazi sèlman kont ki gen yon abònman aktif, donk anyen p ap plase toutotan ou pa abòne.",
      },
    ],
    note: "Ou ka kenbe yon sèl kont konekte san abònman. Y ap refize yon dezyèm kont san abònman toutotan premye a pa abòne, paske chak kont konekte louvri yon koneksyon WebSocket prive ak echanj lan epi echanj yo limite konbyen koneksyon ki soti nan yon menm adrès.",
  },

  "subscribe-to-a-master": {
    title: "Abòne ak yon mèt epi peye soti nan pwòp pòtfèy ou",
    intro:
      "Achte yon abònman pou yon mèt sou youn nan kont echanj ou konekte yo, epi peye soti nan pwòp pòtfèy ou. Etap ki anba yo itilize Polygon (USDC, USDT oswa POL); Ethereum (USDC, USDT oswa ETH, ak menm pòtfèy yo) ak NEAR (USDC, USDT oswa NEAR, ak Meteor Wallet, HERE, HOT oswa Nightly) disponib tou lè w ap peye a.",
    prerequisites: [
      "Yon kont echanj ki konekte (gade titoryèl anvan an — yo achte abònman an pou yon kont presi).",
      "Yon pòtfèy tankou MetaMask ki gen USDC natif sou Polygon PoS.",
      "Yon ti kantite POL pou frè gaz. Sou Polygon yo peye gaz an POL, se pa an MATIC.",
    ],
    steps: [
      {
        name: "Chwazi yon mèt",
        text: "Chwazi mèt ou vle swiv la. Yon kont echanj ka swiv yon sèl mèt, donk si kont ou chwazi a deja ap swiv yon lòt mèt, abòne yon lòt kont.",
      },
      {
        name: "Chwazi yon plan",
        text: "Trimèstriyèl (3 mwa), sis mwa oswa anyèl (12 mwa). Pa gen plan chak mwa. Pri ki parèt lè w ap peye a se pri aktyèl la, yo li l nan moman sa a olye yo pran l nan yon tablo pibliye, donk li toujou ajou.",
      },
      {
        name: "Chwazi kont echanj lan",
        text: "Chwazi kilès nan kont ou konekte yo abònman sa a ap kouvri. Sa enpòtan: idantifyan kont lan ale nan peman an sou chèn nan, epi abònman an rete mare ak kont sa a egzakteman apre sa. Peye pou yon kont pa bay dwa pou lòt yo.",
      },
      {
        name: "Konekte pòtfèy ou epi chwazi kijan w ap peye",
        text: "Konekte MetaMask oswa yon lòt pòtfèy sou Polygon PoS, chain ID 137. Chwazi USDC, USDT oswa POL. Pou yon stablecoin ou siyen yon pèmi yon sèl fwa pou egzakteman pri plan an (yon siyati, pa gen tranzaksyon apwobasyon apa, anyen pa rete apwouve); pou POL kontra a fè w peye pri plan an nan to Chainlink aktyèl la epi li remèt sa ki depase a. twoke aksepte USDC natif Circle emèt la; ansyen jeton bridge yo rele USDC.e la se yon lòt kontra epi nou pa aksepte l, donk verifye kilès pòtfèy ou genyen si apwobasyon an refize.",
      },
      {
        name: "Konfime peman an",
        text: "Konfime tranzaksyon an epi tann jouk yo mete l sou chèn nan. Abònman w aktive lè sèvis peman an wè tranzaksyon an konfime, se pa lè navigatè a retounen — donk yon konfimasyon ki pran tan pa vle di peman an echwe. Yon fwa li aktif, kont lan kòmanse resevwa trade mèt sa a.",
      },
    ],
    note: "Abònman pa ranbousab — ni an pati, ni pworata, ni pou pàn. Anyen pa renouvle otomatikman, paske peman an soti nan pwòp pòtfèy ou epi nou pa estoke okenn mwayen peman. Si yon peman rive pou yon kont ki pa ka resevwa l, nou kenbe l tankou yon abònman annatant pou ou mare l, nou pa rejte l.",
  },

  "set-your-risk-settings": {
    title: "Mete limit risk ou anvan premye trade kopye a",
    intro:
      "Konfigire konbyen chak trade kopye gen dwa riske sou pwòp kont ou, ak limit ki ka refize yon trade nèt. Chak paramèt isit la ka sèlman diminye oswa refize yon trade — okenn pa ka fè l pi gwo.",
    prerequisites: ["Yon kont twoke ak omwen yon kont echanj konekte."],
    steps: [
      {
        name: "Louvri panèl risk la",
        text: "Nan tablo w, louvri panèl paramèt risk yo. Paramèt yo aplike pou chak mèt, ak yon valè pa defo ki kouvri nenpòt mèt ou poko konfigire endividyèlman.",
      },
      {
        name: "Mete risk pou chak trade",
        text: "Sa se pòsyon aktif ki nan kont ou w ap pèdi si yon trade rive nan stop-loss li. Valè pa defo a se 0.35% epi maksimòm nou aksepte se 3%. Se sou li yo kalkile gwosè pozisyon an: yo li aktif ki nan kont ou an dirèk sou echanj lan jis anvan chak trade, yo miltipliye valè sa a ak pousantaj sa a, epi yo divize ak distans ki genyen jouk stop la — donk menm paramèt la bay yon pozisyon pi piti lè stop la pi lwen.",
      },
      {
        name: "Mete limit pozisyon ansanm ak pèt jounalye",
        text: "Maksimòm pozisyon ansanm limite konbyen pozisyon kopye ki ka louvri an menm tan; valè pa defo a se 3. Maksimòm pèt jounalye kanpe nouvo kopi pou rès jounen an lè rezilta jounen an (trade ki fèmen, frè ak funding, plis pwofi oswa pèt trade ki louvri yo) rive nan pòsyon sa a sou aktif ki te nan kont ou lè li te abòne premye fwa — jounen an chanje avèk jounen echanj yo a minwi UTC (8 PM lè New York an ete, 7 PM an ivè) pou kripto, lò ak petwòl menm jan; valè pa defo a se 3%, epi yo li chif la nan pwòp rejis pwofi ak pèt echanj ou, yo pa estime l.",
      },
      {
        name: "Mete limit devyasyon kopi w",
        text: "Sa se konbyen pri gen dwa deplase ant antre mèt la ak kopi pa w anvan yo sote kopi a. Valè pa defo a se 0.5%. Yon kopi ki depase limit sa a yo sote l olye yo redwi gwosè l, paske antre pi ta ak yon pi move pri men menm stop la vle di riske plis pase sa ou te konfigire.",
      },
      {
        name: "Konnen kote kill switch la ye",
        text: "Kill switch la kanpe nouvo trade kopye pou yon mèt imedyatman epi li pa mande okenn kòd konfimasyon — yon kontwòl ki kanpe trading pa dwe janm tann yon imèl. Li pa fèmen pozisyon ki deja louvri, epi li kite stop-loss ak take-profit yo aktif sou echanj lan. Jwenn li anvan ou bezwen l.",
      },
    ],
  },

  "disconnect-or-rotate-a-key": {
    title: "Chanje, deplase oswa retire yon kle echanj",
    intro:
      "Ranplase yon kle sou yon kont ki egziste san ou pa pèdi abònman w, deplase yon kont ant demo ak reyèl, oswa retire yon kont konekte nèt.",
    prerequisites: [
      "Aksè ak adrès imèl kont twoke w, pou kòd verifikasyon an.",
      "Pou yon deplasman demo/reyèl oswa yon retrè: kont lan pa dwe gen okenn pozisyon louvri.",
    ],
    steps: [
      {
        name: "Deside si ou bezwen chanje kle a oswa retire kont lan",
        text: "Chanje kle a si kont lan dwe kontinye egziste — lè w ap rejenere yon kle sou echanj lan, oswa lè w ap deplase ant demo ak reyèl. Chanjman kle a ranplase kle a ak sekrè a sou menm kont lan, donk abònman ki mare ak li a, paramèt risk yo ak nenpòt pozisyon louvri rete tache. Retire sèlman si ou vle kont konekte a disparèt.",
      },
      {
        name: "Chanje kle a",
        text: "Mande yon kòd verifikasyon, epi soumèt nouvo kle API a ak sekrè a pou kont sa a. Ou pa ka chanje echanj lan konsa — yon kle Bybit ak yon kle Binance se de kont diferan — men ou ka chanje paramèt demo/reyèl la, epi nan ka sa a kle a dwe chanje tou, paske yon kle demo pa ka otantifye sou anviwònman reyèl la.",
      },
      {
        name: "Fèmen tout pozisyon anvan ou pase demo a reyèl",
        text: "Pou deplase yon kont ant demo ak reyèl fòk pa gen okenn pozisyon louvri. Nou refize sa olye nou bay yon avètisman, paske se de pwosesis diferan k ap siveye chak anviwònman: deplase yon kont ki gen yon pozisyon louvri ta kite pozisyon sa a ap kouri san pwogram siveyans (watchdog) ki kenbe stop-loss li tache.",
      },
      {
        name: "Retire kont lan",
        text: "Pou retire yon kont fòk gen twa bagay: yon kòd verifikasyon ki valide, pa gen abònman aktif sou kont sa a, epi pa gen pozisyon louvri. Kondisyon abònman an egziste pou kripto ou deja peye pa rete bloke akoz yon efasman. Si kle ki estoke a pa otantifye ankò menm, nou pèmèt ou retire kont lan kanmenm — nan pwen sa a twoke pa ka ni wè ni jere kont lan, donk refize ta sèlman bloke w.",
      },
    ],
    note: "Retire yon kle kanpe kopi sou kont sa a imedyatman, men li pa fèmen pozisyon ki deja louvri. Stop-loss ak take-profit yo rete aktif sou echanj lan, epi ou ka jere yo la.",
  },
};
